import { render, staticRenderFns } from "./ThgMyVehicleDecommissionDialog.vue?vue&type=template&id=963f2822"
import script from "./ThgMyVehicleDecommissionDialog.vue?vue&type=script&lang=ts"
export * from "./ThgMyVehicleDecommissionDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports